import type { AccessGroup, ClientLabelRef } from "types/interfaces/access";

/** Groups in picker order: the seeded order first, then by name. */
export function pickerOrder(groups: AccessGroup[]): AccessGroup[] {
  return [...groups].sort(
    (a, b) => a.sort_order - b.sort_order || a.name.localeCompare(b.name),
  );
}

export function groupName(
  groups: AccessGroup[] | undefined,
  id: number | null | undefined,
): string {
  if (id == null) return "No group";
  return groups?.find((g) => g.id === id)?.name ?? `Group #${id}`;
}

/** Whether a client assigned to a member of `group` changes what they see: a group
 * that sees its assigned clients counts them - only those carrying one of its
 * labels, when it has any. Without a group nothing counts yet. */
export function countsAssignedClient(
  group: AccessGroup | null,
  client: { labels?: ClientLabelRef[] } | undefined,
): boolean {
  if (!group || group.client_scope !== "assigned") return false;
  if (group.client_labels.length === 0) return true;
  return (client?.labels ?? []).some((label) =>
    group.client_labels.includes(label.slug),
  );
}

/** What assigning clients means under `group`, for the Clients step. */
export function assignedClientsNote(group: AccessGroup | null): string | null {
  if (!group) return null;
  const scope = `${group.name} applies to: ${group.applies_to}.`;
  if (group.client_scope !== "assigned")
    return (
      `${scope} Assigned clients do not change what the user sees; they list ` +
      "the user as a Calibrate owner of the client."
    );
  if (group.client_labels.length > 0)
    return `${scope} Only clients of these kinds count, so the list offers only them.`;
  return null;
}
